import React from 'react';
import ReactDOM from 'react-dom/client';
import AdminApp from './AdminApp.jsx';
import { ToastProvider } from './Toaster.jsx';
import '../../shared/base.css';
import './admin.css';

// No router: sign-in versus settings is a matter of whether the session cookie
// resolves, not of a URL.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* Outside the app, so every page inside it - including sign-in - can
        raise a notice, and so no panel has to render one itself. */}
    <ToastProvider>
      <AdminApp />
    </ToastProvider>
  </React.StrictMode>
);
